const requireShipping = (state) => {
  let cartItems = state.cart.cartItems || []

  return cartItems.some((cartItem) => {
    let { requiresShipping, weight } = cartItem.product
    return requiresShipping && weight && parseFloat(weight) > 0
  })
}

export default {
  requireShipping
}
